import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";
// import { supabase } from "../../lib/supabase";

export const useUploadOrganizationDocument = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { name: string; file: any; is_back: boolean }) => {
      const orgId = user?.mfiId;
      if (orgId) {
        const formData = new FormData();
        formData.append("document", data.file);
        formData.append("orgId", orgId);
        formData.append("pageNumber", "1");
        formData.append("documentName", data.name);
        formData.append("isBack", "false");
        const result = await axiosBaseURL.post(
          `/off-taker/upload-document`,
          formData,
          {
            headers: {
              header: `${user?.userId}/${user?.token}`,
              Authorization: authString,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      }

      // return result;
      return;
    },
  });
};

export const useGetOrganizationDocuments = (orgId?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["documents", user?.mfiId],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `off-taker/organization/${orgId}/documents`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

type orgParams = { merchantType?: string; status?: string };
export const useOrganizationsList = (params?: orgParams) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useOrganizationsList"],
    staleTime: 120,
    queryFn: async () => {
      const type = params?.merchantType;
      const _params = type ? `?merchantType=${type}` : "/";
      // const params = status && status !== 'ALL' ? `?status=${status}` : ''
      const result = await axiosBaseURL.get(
        `/off-taker/organizations${_params}`,
        {
          // const result = await axiosBaseURL.get(`/off-taker/organizations`, {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetBranchesList = (status?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["branch"],
    staleTime: 120,
    queryFn: async () => {
      // const params = status && status !== 'ALL' ? `?status=${status}` : ''
      const result = await axiosBaseURL.get(
        `/off-taker/branch?id=${user?.mfiId}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetBrancheById = (id?: string | number) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["organizations", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      // const result = await axiosBaseURL.get(`/off-taker/organizations/${params}`, {
      //     headers: {
      //         header: `${user?.userId}/${user?.token}`,
      //         Authorization: authString,
      //     }
      // });

      return {
        status: "success",
        message: "",
        data: {
          id: 1,
          name: "Commercial Bank of Ethiopia",
          email: "example@cbe.com",
          phoneNumber: "0123456789",
          branchName: "Finfine Branch",
          address:
            '{"region": "Addis Ababa", "city": "Addis ababa", "kifle_ketema": "Arada", "woreda": "01"}',
          contactPerson: {
            id: 1,
            username: "dagtad",
            fullName: "Dagmawi Tadesse",
            roleName: "ROLE_KFT_SUPER_ADMIN",
            email: "dagtade@gmail.com",
            phone: "0911687411",
            organizationId: 1,
            status: "ACTIVE",
          },
          users: [
            {
              id: 1,
              username: "dagtad",
              fullName: "Dagmawi Tadesse",
              roleName: "ROLE_KFT_SUPER_ADMIN",
              email: "dagtade@gmail.com",
              phone: "0911687411",
              organizationId: 1,
              status: "ACTIVE",
            },
          ],
        },
      };
    },
  });
};

export const useGetOrganizationByName = (name?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["organization", name],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/off-taker/organization/name?name=${name}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetOrganizationByPhoneNumber = (phone?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["organization", phone],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/off-taker/organization/phone?number=${phone}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetOrganizationByEmail = (email?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["organization", email],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/off-taker/organization/email?email=${email}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetOrganizationDetail = (id?: number | string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["organizations", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/organizations/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useUpdateOrganizationStatus = () => {
  const { refetch } = useOrganizationsList();
  const { authString, user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { id: string; status: string }) => {
      const result = await axiosBaseURL.put(
        `off-taker/organization/${data.id}?status=${data.status}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
            Authorization: authString,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useCreateBranch = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: {
      name?: string;
      shortName?: string;
      email?: string;
      phoneNumber?: string;
      type?: string;
      address?: string;
      contactPerson: {
        fullName?: string;
        username?: string;
        password?: null;
        email?: string;
        phoneNumber?: string;
      };
    }) => {
      const result = await axiosBaseURL.post(`/off-taker/branch`, data, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};
